import { Injectable } from '@angular/core';
import { BaseApiHandleOptions, BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RodApiService {
    private readonly url: string = 'service/contactcloud/rod/auto/export/settings';

    constructor(
        private readonly baseApiService: BaseApiService,
    ) {
    }

    getRodList(options?: BaseApiHandleOptions): Observable<any> {
        return this.baseApiService.get<any>(this.url, options);
    }

    putRoD(requestBody) {
        return this.baseApiService.put(this.url, requestBody);
    }
}
